/**
 * @generated SignedSource<<07cc10491d67b054db7e5e65a51e9cd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endts"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellername"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startts"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unapprovedOnly"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endts",
        "variableName": "endts"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "resellername",
        "variableName": "resellername"
      },
      {
        "kind": "Variable",
        "name": "startts",
        "variableName": "startts"
      },
      {
        "kind": "Variable",
        "name": "unapprovedonly",
        "variableName": "unapprovedOnly"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "PayoutLinesConnection",
    "kind": "LinkedField",
    "name": "getpayoutlines",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PayoutLine",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vendorPayoutId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cpId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chargeAmountTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statusReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutLinesQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PayoutLinesQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "29f0b4aabfeed3a8bbe4a42387bdaa67",
    "id": null,
    "metadata": {},
    "name": "PayoutLinesQuery",
    "operationKind": "query",
    "text": "query PayoutLinesQuery(\n  $vendorAccountId: UUID!\n  $resellername: String\n  $unapprovedOnly: Int\n  $startts: Datetime\n  $endts: Datetime\n  $first: Int\n  $offset: Int\n) {\n  getpayoutlines(vendoraccountid: $vendorAccountId, resellername: $resellername, unapprovedonly: $unapprovedOnly, startts: $startts, endts: $endts, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      vendorPayoutId\n      resellerAccountId\n      resellerAccountName\n      programName\n      cpId\n      description\n      programType\n      payoutDate\n      startTs\n      endTs\n      chargeAmountTotal\n      payoutAmount\n      approvedBy\n      approvedTime\n      status\n      statusReason\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8f96b00c46b93ceb4b54ecee8414184a";

module.exports = node;
